import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const BlogWizard = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12718"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12718)">
          <rect
            x="-4"
            y="-1"
            width="124"
            height="112"
            rx="6.2098"
            fill="#FFCBCB"
          />
          <path
            d="M87.9816 21.7341H21.0322V97.8041H87.9816V21.7341Z"
            fill="white"
          />
          <path
            d="M41.5619 76.0736H31.0344C30.569 76.0736 30.1227 76.2585 29.7937 76.5875C29.4646 76.9166 29.2798 77.3629 29.2798 77.8282V88.3557C29.2798 88.8211 29.4646 89.2674 29.7937 89.5964C30.1227 89.9255 30.569 90.1103 31.0344 90.1103H41.5619C42.0273 90.1103 42.4736 89.9255 42.8026 89.5964C43.1317 89.2674 43.3165 88.8211 43.3165 88.3557V77.8282C43.3165 77.3629 43.1317 76.9166 42.8026 76.5875C42.4736 76.2585 42.0273 76.0736 41.5619 76.0736Z"
            fill="#66E1FF"
          />
          <path
            d="M42.8042 76.5822C42.6409 76.4193 42.4472 76.2903 42.234 76.2024C42.0209 76.1145 41.7925 76.0694 41.5619 76.0698H31.0344C30.569 76.0698 30.1227 76.2547 29.7937 76.5837C29.4646 76.9128 29.2798 77.3591 29.2798 77.8244V88.352C29.2794 88.5825 29.3244 88.8109 29.4123 89.0241C29.5002 89.2372 29.6293 89.431 29.7921 89.5942L42.8042 76.5822Z"
            fill="#C2F3FF"
          />
          <path
            d="M41.5619 76.0736H31.0344C30.569 76.0736 30.1227 76.2585 29.7937 76.5875C29.4646 76.9166 29.2798 77.3629 29.2798 77.8282V88.3557C29.2798 88.8211 29.4646 89.2674 29.7937 89.5964C30.1227 89.9255 30.569 90.1103 31.0344 90.1103H41.5619C42.0273 90.1103 42.4736 89.9255 42.8026 89.5964C43.1317 89.2674 43.3165 88.8211 43.3165 88.3557V77.8282C43.3165 77.3629 43.1317 76.9166 42.8026 76.5875C42.4736 76.2585 42.0273 76.0736 41.5619 76.0736Z"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.3027 79.9852H77.4706"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.3027 86.1951H77.4706"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.9322 22.1005H21.082V16.76C21.082 15.6088 21.5516 14.5048 22.3874 13.6908C23.2232 12.8768 24.3567 12.4196 25.5387 12.4196H83.4755C84.6575 12.4196 85.7911 12.8768 86.6268 13.6908C87.4626 14.5048 87.9322 15.6088 87.9322 16.76V22.1005Z"
            fill="white"
          />
          <path
            d="M21.0322 95.4757V17.7981C21.0322 16.3717 21.5025 15.0036 22.3395 13.995C23.1765 12.9863 24.3118 12.4197 25.4955 12.4197H83.5183C84.702 12.4197 85.8373 12.9863 86.6743 13.995C87.5113 15.0036 87.9816 16.3717 87.9816 17.7981V95.4757"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.72 35.5853C39.6213 35.5852 39.5254 35.6168 39.4477 35.675C39.37 35.7332 39.3149 35.8146 39.2913 35.9062L37.0093 44.6265H42.4275L40.1502 35.9062C40.1265 35.8144 40.0712 35.7328 39.9932 35.6745C39.9152 35.6163 39.8189 35.5849 39.72 35.5853ZM39.72 32.5715C40.5218 32.5713 41.3007 32.8274 41.9327 33.2993C42.5647 33.7711 43.0135 34.4315 43.2076 35.1754L45.9687 45.7356L45.9845 45.7989L47.5526 51.7962C47.6068 51.9894 47.6203 52.1911 47.5921 52.3893C47.564 52.5875 47.4949 52.7784 47.3887 52.9509C47.2826 53.1233 47.1417 53.2738 46.9741 53.3936C46.8065 53.5134 46.6157 53.6 46.4127 53.6486C46.2097 53.6971 45.9986 53.7065 45.7918 53.6762C45.585 53.6459 45.3866 53.5765 45.2081 53.4721C45.0296 53.3677 44.8746 53.2304 44.7522 53.0681C44.6298 52.9059 44.5425 52.7219 44.4952 52.527L43.2186 47.6403H36.2213L34.9447 52.5255C34.8975 52.7204 34.8101 52.9044 34.6877 53.0666C34.5653 53.2289 34.4104 53.3662 34.2319 53.4706C34.0534 53.575 33.8549 53.6444 33.6481 53.6747C33.4413 53.705 33.2302 53.6956 33.0272 53.6471C32.8243 53.5985 32.6334 53.5119 32.4658 53.3921C32.2982 53.2723 32.1573 53.1218 32.0512 52.9494C31.9451 52.7769 31.8759 52.586 31.8478 52.3878C31.8197 52.1895 31.8331 51.9879 31.8873 51.7947L33.4539 45.7974C33.4587 45.7767 33.4639 45.7561 33.4696 45.7356L36.2323 35.1754C36.4264 34.4315 36.8752 33.7711 37.5072 33.2993C38.1392 32.8274 38.9181 32.5713 39.72 32.5715Z"
            fill="#191919"
          />
          <path
            d="M55.9512 40.2523H77.2149"
            stroke="#191919"
            strokeWidth="1.44014"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.9512 47.9332H77.2149"
            stroke="#191919"
            strokeWidth="1.44014"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.4702 61.1645H77.2148"
            stroke="#191919"
            strokeWidth="1.44014"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.4702 68.8452H77.2148"
            stroke="#191919"
            strokeWidth="1.44014"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.082 22.1004H87.9322"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.853 74.9942L99.9358 76.8613L93.5454 70.6376L95.4625 68.7705C96.3146 67.9672 97.4567 67.5223 98.6425 67.5316C99.8284 67.541 100.963 68.004 101.801 68.8206C102.64 69.6373 103.115 70.7423 103.125 71.8972C103.135 73.0521 102.678 74.1644 101.853 74.9942Z"
            fill="#FF808C"
          />
          <path
            d="M86.5672 89.881L77.6206 92.3705L80.1768 83.6573L86.5672 89.881Z"
            fill="#FFBC44"
          />
          <path
            d="M93.5455 70.6401L80.1768 83.6601L86.5672 89.8838L99.9359 76.8638L93.5455 70.6401Z"
            fill="#FFEF5E"
          />
          <path
            d="M101.853 74.9942L99.9358 76.8613L93.5454 70.6376L95.4625 68.7705C96.3146 67.9672 97.4567 67.5223 98.6425 67.5316C99.8284 67.541 100.963 68.004 101.801 68.8206C102.64 69.6373 103.115 70.7423 103.125 71.8972C103.135 73.0521 102.678 74.1644 101.853 74.9942Z"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.5672 89.881L77.6206 92.3705L80.1768 83.6573L86.5672 89.881Z"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M93.5455 70.6401L80.1768 83.6601L86.5672 89.8838L99.9359 76.8638L93.5455 70.6401Z"
            stroke="#191919"
            strokeWidth="1.16434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
BlogWizard.displayName = 'BlogWizard';
